<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="rolesSelected"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    :items="roles"
    :loading="rolesLoading"
    :search-input.sync="rolesSearch"
    item-text="role_name"
    item-value="id"
    :label="noLabel ? '' : label ? label : $t('SmsPushSetting.TableTitle.role')"
    return-object
  ></v-autocomplete>
  <!-- menu-props="closeOnContentClick" -->
</template>

<script>
import Roles from "@/api/roles";

export default {
  name: "SearcherShops",

  props: [
    "value",
    "label",
    "noLabel"
  ],

  computed: {

  },

  data: () => ({
    roles: [],
    rolesLoading: false,
    rolesSearch: "",
    rolesSelected: [],
  }),

  mounted() {
    this.getRolesFromAPI();
  },

  methods: {
    getRolesFromAPI() {
      this.rolesLoading = true;
      Roles.fetchAll()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.roles = response.data.roles;
            }
            this.rolesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.rolesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.rolesSelected = this.value;
      },
    },
    rolesSelected: {
      handler() {
        this.$emit("input", this.rolesSelected);
      },
    },
  },
};
</script>
